import { css } from "styled-components";
import {getFontSize, getLetterSpacing} from "@/pipes/theme.pipe";
import {getButtonPaddings} from "@/components/UI/Button/Button.utils";

const sizeOptions = {
    xs: css`
        font-size: clamp(${getFontSize('button', 'xs')}, 4vw, ${getFontSize('button', 'xs')});
        letter-spacing: ${getLetterSpacing('xs')};
        
        width: 80px !important;
        padding: 0 !important;

        .ant-select-item.ant-select-item-option {
            padding: 5px !important;
        }
        
        .ant-select-selector {
            ${getButtonPaddings('xs')};
            height: 30px !important;
        }
        
        .ant-select-arrow {
            zoom: .6;
        }

        .ant-select-item {
            padding: 5px 20px !important;
        }
    `,
    sm: css`
        font-size: clamp(${getFontSize('button', 'xs')}, 4vw, ${getFontSize('button', 'sm')});
        letter-spacing: ${getLetterSpacing('sm')};
        line-height: 35px;
        
        .ant-select-selector {
            ${getButtonPaddings('sm')};
        }
    `,
    md: css``,
    auto: css`
        width: fit-content;
        padding: 0;
        letter-spacing: ${getLetterSpacing('md')};
    `
}

export const getSizeOptions = ({size}) => sizeOptions[size] || sizeOptions['md']